import script from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=65ca1f4d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ca1f4d"]])

export default __exports__